var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ranking-bar",style:({ width: _vm.barWidth + 'px' })},[_c('div',{staticClass:"ranking-bar__fill",style:({ width: _vm.fillWidth + 'px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }